import React from "react";

import { Experience } from "@/types";
import { getCountryOption } from "@/utils/getCountryOption";
import { getLanguageOption } from "@/utils/getLanguageOption";

const ExperienceContext = React.createContext<Experience>({
  allCountryOptions: [],
  confirmedHCP: true,
  cookieCountry: getCountryOption("US"),
  countryOptions: [],
  documentIds: [],
  environment: "local",
  globalCountryOptions: [],
  pathCountry: getCountryOption("US"),
  pathCountrySupported: true,
  pathLanguage: getLanguageOption("en"),
  userCountry: getCountryOption("US"),
  userLanguage: getLanguageOption("en"),
  userLanguageCountry: getCountryOption("US")
});

export const ExperienceProvider: React.FC<React.PropsWithChildren<{ experience: Experience }>> = ({
  children,
  experience
}) => {
  const { cookieCountry, pathLanguage } = experience;
  const countryCode = cookieCountry?.iso2 || "US";
  const languageCode = pathLanguage?.iso2 || "en";

  React.useEffect(() => {
    document.documentElement.setAttribute("lang", languageCode);
    const locale = `${languageCode}-${countryCode}`;
    const amplitudeScript = document.querySelector("script[data-amplitude-key]");
    amplitudeScript?.setAttribute("data-locale", locale);
  }, [countryCode, languageCode]);

  return <ExperienceContext.Provider value={experience}>{children}</ExperienceContext.Provider>;
};

export const useExperience = () => React.useContext(ExperienceContext);
